// extracted by mini-css-extract-plugin
var _1 = "AuditLogContentView-module__emptyStateContainer--ufwAb";
var _2 = "AuditLogContentView-module__loadingContainer--xrZo9";
export { _1 as "emptyStateContainer", _2 as "loadingContainer" }
